import { Box } from '@mui/material';
import React from 'react';
import { IZone, IZoneLog } from '../../models';
import { usePublicZoneLogs } from '../../pages/zones/zones.hook';
import { CleaningHistoryBlock } from './cleaning-history-block';

interface CodeLastServiceProps {
  zone: IZone;
}

export const CodeLastService = (props: CodeLastServiceProps) => {
  const [lastServiceLog, setLastServiceLog] = React.useState<IZoneLog>();
  const [loading_logs, logs] = usePublicZoneLogs({ zoneId: props.zone.id, limit: 30 });

  React.useEffect(() => {
    if (!loading_logs && logs.length > 0) {
      setLastServiceLog(logs[0]);
    }
  }, [loading_logs]);

  return (
    <Box sx={{ width: '100%' }}>
      {lastServiceLog && <CleaningHistoryBlock log={lastServiceLog} title="Last Service" showDate />}
    </Box>
  );
};
